(function () {
  'use strict';

  if (window.__snCardSystemV40) return;
  window.__snCardSystemV40 = true;

  var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  var cartPromise = null;

  function number(value) {
    var result = parseInt(value, 10);
    return Number.isFinite(result) ? result : 0;
  }

  function getCartQuantity(variantId) {
    var cart = window.__snCartState;
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce(function (sum, item) {
      return Number(item.variant_id) === Number(variantId) ? sum + number(item.quantity) : sum;
    }, 0);
  }

  function updateCartCount(cart) {
    var count = cart && Number.isFinite(Number(cart.item_count)) ? Number(cart.item_count) : 0;
    document.querySelectorAll('cart-count, .cart-count, .cart-bubble').forEach(function (element) {
      element.textContent = count > 99 ? '99+' : String(count);
      element.toggleAttribute('hidden', count === 0);
      element.setAttribute('aria-label', count + ' artiklar i varukorgen');
    });
    if (window.__snUpdateDrawerCount) window.__snUpdateDrawerCount(count);
  }

  function bumpCartIcon() {
    var icon = document.querySelector('.cart-drawer-button');
    if (!icon) return;
    icon.classList.remove('sn-cart-bump');
    // Force a restart when a customer adds items repeatedly in quick succession.
    void icon.offsetWidth;
    icon.classList.add('sn-cart-bump');
    clearTimeout(icon.__snBumpTimer);
    icon.__snBumpTimer = setTimeout(function () {
      icon.classList.remove('sn-cart-bump');
    }, 520);
  }

  function updateButton(card) {
    var button = card.querySelector('[data-add-to-cart]');
    var select = card.querySelector('[data-sn-select]');
    if (!button || button.__snAdding) return;

    if (select && select.options.length) {
      var option = select.options[select.selectedIndex];
      button.dataset.variantId = option.value;
      button.dataset.maxAntal = option.dataset.maxAntal || '';
      if (option.dataset.available === 'false') {
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.title = 'Slut i lager';
        return;
      }
    }

    var variantId = number(button.dataset.variantId);
    var max = number(button.dataset.maxAntal);
    var atMaximum = max > 0 && getCartQuantity(variantId) >= max;
    button.disabled = atMaximum;
    button.setAttribute('aria-disabled', String(atMaximum));
    button.title = atMaximum ? 'Max antal uppnått' : '';
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-sn-card]').forEach(updateButton);
  }

  function fetchCart(force) {
    if (cartPromise && !force) return cartPromise;
    cartPromise = fetch(root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Varukorgen kunde inte hämtas.');
        return response.json();
      })
      .then(function (cart) {
        window.__snCartState = cart;
        window.__cartItems = cart.items || [];
        updateCartCount(cart);
        updateAllButtons();
        return cart;
      })
      .catch(function (error) {
        console.error('Snusarna produktkort:', error);
        return window.__snCartState || { items: [], item_count: 0 };
      })
      .finally(function () { cartPromise = null; });
    return cartPromise;
  }

  function showToast() {}

  function sectionIdFor(element) {
    if (element && element.getAttribute('data-section-id')) return element.getAttribute('data-section-id');
    var section = element && element.closest('[id^="shopify-section-"]');
    return section ? section.id.replace('shopify-section-', '') : '';
  }

  function replaceSectionParts(sectionId, html) {
    if (!sectionId || !html) return;
    var target = document.getElementById('shopify-section-' + sectionId);
    if (!target) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    // Replace the empty state too, including the server-rendered hidden classes.
    ['CartDrawerEmpty-', 'CartDrawerBody-', 'CartDrawerFooter-'].forEach(function (prefix) {
      var id = prefix + sectionId;
      var current = target.querySelector('[id="' + id + '"]');
      var replacement = doc.getElementById(id);
      if (current && replacement) current.replaceWith(replacement);
    });
  }

  function refreshDrawer(addResult) {
    var drawer = document.querySelector('cart-drawer');
    var sectionId = sectionIdFor(drawer);
    if (!drawer || !sectionId) return Promise.resolve();
    if (addResult && addResult.sections && addResult.sections[sectionId]) {
      replaceSectionParts(sectionId, addResult.sections[sectionId]);
      return Promise.resolve();
    }
    return fetch(root + '?sections=' + encodeURIComponent(sectionId), {
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    }).then(function (response) {
      return response.ok ? response.json() : {};
    }).then(function (sections) {
      replaceSectionParts(sectionId, sections[sectionId]);
    }).catch(function (error) {
      console.error('Varukorgslådan kunde inte uppdateras:', error);
    });
  }

  function showCardError(card, text) {
    var message = card.querySelector('[data-sn-card-error]');
    if (!message) {
      message = document.createElement('p');
      message.dataset.snCardError = '';
      message.className = 'sn-card__error';
      message.setAttribute('role', 'status');
      card.querySelector('.sn-card__body').appendChild(message);
    }
    message.textContent = text || '';
    message.hidden = !text;
  }

  function normalizeCardSurface(card) {
    if (!card || card.closest('.sn-search')) return;
    var imageArea = card.querySelector('.sn-card__imglink');
    var infoArea = card.querySelector('.sn-card__body');
    if (imageArea) imageArea.style.setProperty('background', '#ffffff', 'important');
    if (infoArea) infoArea.style.setProperty('background', '#f7f7f7', 'important');
  }

  function bindCard(card) {
    if (!card || card.dataset.snCardReady === 'true') return;
    card.dataset.snCardReady = 'true';
    normalizeCardSurface(card);
    var select = card.querySelector('[data-sn-select]');
    var button = card.querySelector('[data-add-to-cart]');
    var price = card.querySelector('[data-sn-price]');
    var unitPrice = card.querySelector('[data-sn-unit-price]');
    if (!button) return;

    if (select && card.dataset.defaultVariantId) {
      Array.prototype.some.call(select.options, function (option, index) {
        if (String(option.value) !== String(card.dataset.defaultVariantId)) return false;
        select.selectedIndex = index;
        return true;
      });
    }

    function syncSelection() {
      if (!select || !select.options.length) return;
      var option = select.options[select.selectedIndex];
      button.dataset.variantId = option.value;
      button.dataset.maxAntal = option.dataset.maxAntal || '';
      if (price && option.dataset.price) price.textContent = (number(option.dataset.price) / 100).toFixed(2).replace('.', ',') + ' kr';
      if (unitPrice) unitPrice.textContent = option.dataset.unitLabel || '';
      showCardError(card, '');
      updateButton(card);
    }

    if (select) select.addEventListener('change', syncSelection);
    syncSelection();

    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled || button.__snAdding) return;
      var variantId = number(button.dataset.variantId);
      if (!variantId) return;
      var max = number(button.dataset.maxAntal);
      if (max > 0 && getCartQuantity(variantId) >= max) {
        updateButton(card);
        showCardError(card, 'Max antal uppnått för denna variant.');
        return;
      }

      button.__snAdding = true;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      card.classList.add('is-adding');
      showCardError(card, '');

      // Keep the add response small: render the drawer only after the add is confirmed.
      var payload = { id: variantId, quantity: 1 };

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-SN-Owns-Cart-Refresh': '1' },
        body: JSON.stringify(payload)
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Produkten kunde inte läggas till.');
          return data;
        });
      }).then(function (addResult) {

        showToast();
        // Purchase feedback is already shown by the shared fetch handler.
        // Keep repeat-click protection until cart quantities have been reconciled.
        return Promise.all([refreshDrawer(addResult), fetchCart(true)]);
      }).then(function (results) {
        var cart = results[1];
        if (window.FoxTheme && window.FoxTheme.pubsub && cart) {
          window.FoxTheme.pubsub.publish('cart-update', { cart: cart, errors: [] });
        }
      }).catch(function (error) {
        showCardError(card, error.message || 'Produkten kunde inte läggas till. Försök igen.');
      }).finally(function () {
        button.__snAdding = false;
        button.removeAttribute('aria-busy');
        card.classList.remove('is-adding');
        updateButton(card);
      });
    });
  }

  function bindCards(rootElement) {
    var scope = rootElement && rootElement.querySelectorAll ? rootElement : document;
    if (scope.matches && scope.matches('[data-sn-card]')) bindCard(scope);
    scope.querySelectorAll('[data-sn-card]').forEach(bindCard);
    updateAllButtons();
  }

  function installPurchaseFeedback() {
    if (window.__snPurchaseFeedback) return;
    window.__snPurchaseFeedback = true;
    var clickedButton = null;
    var selector = '[data-add-to-cart], [data-pdp-add-to-cart], [data-product-add-to-cart], product-form button[type="submit"], button[name="add"], input[type="submit"], .sn-card__buy, .sn-buy';
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest(selector);
      if (button && !button.disabled) clickedButton = { element: button, time: Date.now() };
    }, true);

    function clearSuccessStyle(button) {
      if (!button || !button.__snSuccessStyle) return;
      var saved = button.__snSuccessStyle;
      ['background', 'background-color', 'background-image', 'border-color'].forEach(function (property) {
        var state = saved[property];
        if (state && state.value) button.style.setProperty(property, state.value, state.priority);
        else button.style.removeProperty(property);
      });
      button.__snSuccessStyle = null;
    }

    function applySuccessStyle(button) {
      if (!button) return;
      if (!button.__snSuccessStyle) {
        button.__snSuccessStyle = {};
        ['background', 'background-color', 'background-image', 'border-color'].forEach(function (property) {
          button.__snSuccessStyle[property] = {
            value: button.style.getPropertyValue(property),
            priority: button.style.getPropertyPriority(property)
          };
        });
      }
      button.style.setProperty('background', '#2f8a63', 'important');
      button.style.setProperty('background-color', '#2f8a63', 'important');
      button.style.setProperty('background-image', 'none', 'important');
      button.style.setProperty('border-color', '#2f8a63', 'important');
    }

    var originalFetch = window.fetch;
    window.fetch = function (input, options) {
      var url = typeof input === 'string' ? input : String(input && input.url || input || '');
      if (!/\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url)) return originalFetch.apply(this, arguments);
      var button = clickedButton && Date.now() - clickedButton.time < 5000 ? clickedButton.element : null;
      clickedButton = null;
      if (button) {
        clearSuccessStyle(button);
        button.classList.remove('sn-buy-success');
        button.classList.add('sn-buy-pending');
        button.setAttribute('aria-busy', 'true');
      }
      var request;
      try { request = originalFetch.apply(this, arguments); }
      catch (error) { if (button) button.classList.remove('sn-buy-pending'); throw error; }
      return request.then(function (response) {
        if (response.ok) {
          bumpCartIcon();
          if (button) {
            applySuccessStyle(button);
            button.classList.add('sn-buy-success');
            clearTimeout(button.__snSuccessTimer);
            button.__snSuccessTimer = setTimeout(function () {
              button.classList.remove('sn-buy-success');
              clearSuccessStyle(button);
            }, 1200);
          }
        }
        return response;
      }).finally(function () {
        if (button) { button.classList.remove('sn-buy-pending'); button.removeAttribute('aria-busy'); }
      });
    };
  }

  function init() {
    installPurchaseFeedback();
    bindCards(document);
    fetchCart(false);
    new MutationObserver(function (records) {
      var shouldBind = records.some(function (record) {
        return Array.prototype.some.call(record.addedNodes, function (node) {
          return node.nodeType === 1 && (node.matches('[data-sn-card]') || node.querySelector('[data-sn-card]'));
        });
      });
      if (shouldBind) bindCards(document);
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.__snBindCards = bindCards;
  window.__snBumpCartIcon = bumpCartIcon;
  window.__snUpdateCartState = function (callback) {
    return fetchCart(true).then(function (cart) {
      if (typeof callback === 'function') callback(cart);
      return cart;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
